const Search = () => {
  const searchOpen = document.getElementById('searchOpen');
  const searchFormContainer = document.getElementById('searchContainer');

  const searchForm = document.getElementById('search-block-form');
  const searchInput = searchForm.querySelector('input[type="search"]');
  searchInput.setAttribute('placeholder', 'Search...');
  // const searchClose = document.getElementById('searchClose');

  if (!searchOpen || !searchFormContainer) return;

  searchOpen.addEventListener('click', () => {
    searchFormContainer.classList.toggle('visible');
  });

  const pageSearchForm = document.querySelector('#search-form');
  if (pageSearchForm) {
    pageSearchForm.innerHTML += `<div class="non-animated-container">
        <div
          class="non-animated line right"
        ></div></div>
    `;
  }
};

export default Search;
